import React, { createContext, useState } from 'react'

export interface ReportObjectType {
  id:''
  status: ''
  customerName:string
  productionPace:string
  producerName:string
  producerCostTotal:number
  machine:string
  startTime?:string
  endTime?:string
}

const initialReportState: ReportObjectType = {
  id: '',
  status: '',
  customerName:'',
  productionPace:'',
  producerName:'',
  producerCostTotal:0,
  machine:''
}

interface ReportContextProps {
  report: ReportObjectType
  setReport: React.Dispatch<React.SetStateAction<ReportObjectType>>
}

export const ReportContext = createContext<ReportContextProps>({
  report: initialReportState,
  setReport: () => {}
})

export const ReportProvider: React.FC<any> = ({ children }) => {
  const [report, setReport] = useState<ReportObjectType>(initialReportState)

  return (
    <ReportContext.Provider value={{
      report,
      setReport
    }}>
      {children}
    </ReportContext.Provider>
  )
}
